import React, { Suspense, useEffect } from 'react';
import { useRoutes } from 'react-router-dom';

import { CSpinner, useColorModes } from '@coreui/react';
import './scss/style.scss';
import AuthGuard from './hooks/auth/AuthGuard';

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'));

// Pages
const Login = React.lazy(() => import('./Templates/pages/login/Login'));
const Page404 = React.lazy(() => import('./Templates/pages/page404/Page404'));
const Page500 = React.lazy(() => import('./Templates/pages/page500/Page500'));

// Define your routes as an array
const routes = [
  {
    element: (
      <AuthGuard>
        <DefaultLayout />
      </AuthGuard>
    ),
    children: [
   
      {
        path: '/*',
        element: <DefaultLayout />,
      },

    ]
  },
  { path: '/', element: <Login /> },
  { path: '/login', element: <Login /> },
  { path: '/404', element: <Page404 /> },
  { path: '/500', element: <Page500 /> },
];

const App = () => {
  const { setColorMode } = useColorModes('coreui-free-react-admin-template-theme');
  useEffect(() => {
    setColorMode('light');
  }, [setColorMode]);

  // Use the useRoutes hook to get the matched element
  const content = useRoutes(routes);

  return (
    <>
      <Suspense
        fallback={
          <div className="pt-3 text-center">
            <CSpinner color="primary" variant="grow" />
          </div>
        }
      >
        {content}
      </Suspense>
    </>
  );
};

export default App;
